import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterList } from '@ukam/core/searchs/filter-list';
import { IdCodeName } from '@ukam/core/models/id-code-name';
import { CountResult } from '@ukam/core/searchs/count-result';
import { SearchResult } from '@ukam/core/searchs/search-result';
import { IdListParams } from '@ukam/core/params/id-list.params';
import { Filter } from '../models/filter';
import { FilterFilter } from '../params/filter-filter.params';
import { FilterParams } from '../params/filter.params';
import { API_BASE_URL } from '@ukam/core/tokens/api-base-url.token';

@Injectable({
  providedIn: 'root',
})
export class FilterApiService {
  private readonly apiBaseUrl = inject(API_BASE_URL);

  private readonly http = inject(HttpClient);
  private readonly url = `${this.apiBaseUrl}/filters`;

  public getById(id: string): Observable<Filter> {
    return this.http.get<Filter>(`${this.url}/${id}`);
  }

   public getByFeature(feature: string): Observable<Filter> {
    return this.http.get<Filter>(`${this.url}/features/${feature}`);
  }

  public create(params: FilterParams): Observable<Filter> {
    return this.http.post<Filter>(this.url, params);
  }

  public update(id: string, params: FilterParams): Observable<Filter> {
    return this.http.put<Filter>(`${this.url}/${id}`, params);
  }

  public delete(id: string): Observable<CountResult> {
    return this.http.delete<CountResult>(`${this.url}/${id}`);
  }

  public batchDelete(params: IdListParams): Observable<CountResult> {
    return this.http.post<CountResult>(`${this.url}/batch-delete`, params);
  }

  public batchRestore(params: IdListParams): Observable<CountResult> {
    return this.http.post<CountResult>(`${this.url}/batch-restore`, params);
  }

  public search(filter: FilterFilter): Observable<SearchResult<Filter>> {
    return this.http.post<SearchResult<Filter>>(`${this.url}/search`, filter);
  }

  public searchSimple(filter: FilterFilter): Observable<SearchResult<IdCodeName>> {
    return this.http.post<SearchResult<IdCodeName>>(`${this.url}/search/simple`, filter);
  }

  public getFilterFields(): Observable<FilterList> {
    return this.http.get<FilterList>(`${this.url}/filters`);
  }

    public getFields(feature: string): Observable<any> {
    return this.http.get<any>(`${this.url}/fields/${feature}`);
  }
}
